module.exports = __webpack_public_path__ + "static/VWT20_Funktion02_Temp_800x800-200x200-7d21a8062e94c84cabb6de1f3f1cfc9d.png";